<template>
  <svg
    width="41"
    height="42"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="21" r="20.5" fill="#F1F8FF" />
    <path
      d="M18.235 12.359C18.972 12.2819 19.7142 12.2693 20.4534 12.3213C20.5108 12.2233 20.5448 12.1134 20.5526 12C20.5605 11.8867 20.5419 11.7731 20.4985 11.6682C20.4012 11.4917 20.2627 11.3413 20.0948 11.2298C19.927 11.1182 19.7347 11.0488 19.5343 11.0274C19.2554 10.9717 18.9662 11.0013 18.7044 11.1125C18.4426 11.2238 18.2205 11.4113 18.0671 11.6508C18.0208 11.7679 18.0031 11.8944 18.0156 12.0198C18.028 12.1451 18.0702 12.2656 18.1386 12.3714C18.1742 12.3838 18.2027 12.3912 18.235 12.359Z"
      fill="url(#paint0_linear_2001_4390)"
    />
    <path
      d="M28.4923 16.9753C26.3521 13.897 22.8898 12.5787 19.253 12.6345C16.5833 12.6674 14.0189 13.6809 12.0481 15.4821C11.2655 16.1902 10.6433 17.0574 10.2234 18.0257C9.8035 18.994 9.59549 20.0408 9.61337 21.0961H29.6922C29.7299 19.6312 29.3105 18.191 28.4923 16.9753Z"
      fill="url(#paint1_linear_2001_4390)"
    />
    <path
      d="M30.284 21.8471C30.2552 21.7497 30.2033 21.6608 30.1325 21.5881C30.0617 21.5154 29.9743 21.461 29.8778 21.4297H9.55482C9.439 21.4661 9.3269 21.4297 9.21894 21.4996C8.87561 21.7015 9.03362 22.1887 9.05348 22.5093C9.09121 22.6046 9.15406 22.6879 9.23535 22.7503C9.31663 22.8127 9.41331 22.8519 9.51511 22.8638H29.7011C29.8468 22.8794 29.9934 22.8429 30.1148 22.7608C30.1561 22.7194 30.2062 22.6367 30.2306 22.6367C30.2939 22.3786 30.3119 22.1114 30.284 21.8471Z"
      fill="url(#paint2_linear_2001_4390)"
    />
    <path
      d="M13.7956 24.4144C13.7664 24.4503 13.7461 24.4927 13.7366 24.538C13.7271 24.5834 13.7286 24.6303 13.7411 24.675C13.9351 25.0307 14.3392 24.9409 14.7036 24.967C14.693 25.0038 14.6902 25.0424 14.6952 25.0803C14.7003 25.1182 14.7132 25.1547 14.733 25.1875C14.9022 25.4948 15.2546 25.4357 15.5603 25.4563C15.5331 25.5096 15.5278 25.5713 15.5454 25.6284C15.5876 25.6971 15.6451 25.7552 15.7133 25.7982C15.7815 25.8412 15.8586 25.868 15.9388 25.8766H20.5927L20.6018 24.2501H14.2391C14.0758 24.2468 13.9174 24.3055 13.7956 24.4144Z"
      fill="url(#paint3_linear_2001_4390)"
    />
    <path
      d="M26.7337 24.2422H23.9941V30.7063H26.73L26.7337 24.2422Z"
      fill="url(#paint4_linear_2001_4390)"
    />
    <path
      d="M20.9365 27.4128H23.0374V24.2422H20.9369L20.9365 27.4128ZM21.3502 26.6902C21.3788 26.6591 21.4134 26.6342 21.4519 26.6168C21.4904 26.5994 21.532 26.59 21.5743 26.589C21.6165 26.588 21.6585 26.5956 21.6977 26.6112C21.737 26.6268 21.7727 26.6501 21.8027 26.6798C21.8357 26.7195 21.8591 26.7663 21.8711 26.8165C21.883 26.8667 21.8833 26.919 21.8718 26.9694C21.8415 27.0533 21.7802 27.1224 21.7005 27.1625C21.6554 27.1805 21.6068 27.1881 21.5584 27.1848C21.5099 27.1816 21.4628 27.1674 21.4205 27.1435C21.3497 27.0893 21.3009 27.0113 21.2832 26.9239C21.2785 26.8823 21.2822 26.8402 21.2939 26.8001C21.3057 26.76 21.3254 26.7226 21.3518 26.6902H21.3502Z"
      fill="url(#paint5_linear_2001_4390)"
    />
    <path
      d="M27.0782 31.0777H25.6172V31.4963H29.577V24.2422H27.0778L27.0782 31.0777Z"
      fill="url(#paint6_linear_2001_4390)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2001_4390"
        x1="19.283"
        y1="11"
        x2="19.283"
        y2="12.382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2001_4390"
        x1="19.6534"
        y1="12.6328"
        x2="19.6534"
        y2="21.0961"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2001_4390"
        x1="19.6484"
        y1="21.4297"
        x2="19.6484"
        y2="22.8673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2001_4390"
        x1="17.1661"
        y1="24.25"
        x2="17.1661"
        y2="25.8766"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2001_4390"
        x1="25.3639"
        y1="24.2422"
        x2="25.3639"
        y2="30.7063"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2001_4390"
        x1="21.987"
        y1="24.2422"
        x2="21.987"
        y2="27.4128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2001_4390"
        x1="27.5971"
        y1="24.2422"
        x2="27.5971"
        y2="31.4963"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
